import { path } from './ramdaReplacement';

const leadingZero = (n?: number): string => ((n || n === 0) && n < 10 ? `0${n}` : n ? `${n}` : '');

export const formatPartialDate = (dateArray: PartialDate | undefined | null): string =>
  path([0], dateArray) &&
  path([1], dateArray) &&
  path([1], dateArray) !== '-' &&
  path([2], dateArray) &&
  path([2], dateArray) !== '-'
    ? `${dateArray?.[0]}-${leadingZero(dateArray?.[1] ?? undefined)}-${leadingZero(dateArray?.[2] ?? undefined)}`
    : path([0], dateArray) && path([1], dateArray) && path([1], dateArray) !== '-'
      ? `${dateArray?.[0]}-${leadingZero(dateArray?.[1] ?? undefined)}`
      : path([0], dateArray)
        ? `${dateArray?.[0]}`
        : '';
